import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

// FIQ-1554: read-only - listing types can never trigger a scan or remap on the server.
// This deliberately sends a GraphQL *query* through mutate(): mutate always hits the
// network, so the type list is never served from a client-side cache. The same pattern
// is used by stats-for-register in this plugin.
export const typesForRegister = api(
    (registerId, search = "", filter = "all", sort = "type") =>
        registerId &&
        query(
            gql`
                query TypesForRegister($registerId: String!, $search: String, $filter: String, $sort: String) {
                    typesForRegister(registerId: $registerId, search: $search, filter: $filter, sort: $sort)
                }
            `,
            { registerId, search, filter, sort },
            { returns: "typesForRegister" }
        )
)
